export const PALETTES = {
  cobalt: {
    name: 'Cobalt Blue',
    nameAr: 'الأزرق الكوبالت',
    primary: '#2563eb',
    primaryDark: '#1d4ed8',
    primaryLight: '#3b82f6',
    primarySubtle: '#eff6ff',
    primaryLighter: '#dbeafe',
    accent: '#f97316',
    // Dark mode variants
    dark: {
      primary: '#3b82f6',
      primaryDark: '#2563eb',
      primaryLight: '#60a5fa',
      primarySubtle: '#1e293b',
      primaryLighter: '#1e3a5f',
    },
  },
  emerald: {
    name: 'Emerald Green',
    nameAr: 'الأخضر الزمردي',
    primary: '#059669',
    primaryDark: '#047857',
    primaryLight: '#10b981',
    primarySubtle: '#ecfdf5',
    primaryLighter: '#d1fae5',
    accent: '#f59e0b',
    dark: {
      primary: '#10b981',
      primaryDark: '#059669',
      primaryLight: '#34d399',
      primarySubtle: '#1e293b',
      primaryLighter: '#1a3a2a',
    },
  },
  purple: {
    name: 'Royal Purple',
    nameAr: 'البنفسجي الملكي',
    primary: '#7c3aed',
    primaryDark: '#6d28d9',
    primaryLight: '#8b5cf6',
    primarySubtle: '#f5f3ff',
    primaryLighter: '#ede9fe',
    accent: '#ec4899',
    dark: {
      primary: '#8b5cf6',
      primaryDark: '#7c3aed',
      primaryLight: '#a78bfa',
      primarySubtle: '#1e293b',
      primaryLighter: '#2d1f54',
    },
  },
  orange: {
    name: 'Sunset Orange',
    nameAr: 'البرتقالي',
    primary: '#ea580c',
    primaryDark: '#c2410c',
    primaryLight: '#f97316',
    primarySubtle: '#fff7ed',
    primaryLighter: '#ffedd5',
    accent: '#2563eb',
    dark: {
      primary: '#f97316',
      primaryDark: '#ea580c',
      primaryLight: '#fb923c',
      primarySubtle: '#1e293b',
      primaryLighter: '#3d2510',
    },
  },
  rose: {
    name: 'Rose Pink',
    nameAr: 'الوردي',
    primary: '#e11d48',
    primaryDark: '#be123c',
    primaryLight: '#f43f5e',
    primarySubtle: '#fff1f2',
    primaryLighter: '#ffe4e6',
    accent: '#7c3aed',
    dark: {
      primary: '#f43f5e',
      primaryDark: '#e11d48',
      primaryLight: '#fb7185',
      primarySubtle: '#1e293b',
      primaryLighter: '#3d1520',
    },
  },
  slate: {
    name: 'Slate Neutral',
    nameAr: 'الرمادي المحايد',
    primary: '#475569',
    primaryDark: '#334155',
    primaryLight: '#64748b',
    primarySubtle: '#f8fafc',
    primaryLighter: '#f1f5f9',
    accent: '#2563eb',
    dark: {
      primary: '#64748b',
      primaryDark: '#475569',
      primaryLight: '#94a3b8',
      primarySubtle: '#1e293b',
      primaryLighter: '#283548',
    },
  },
}

export const DEFAULT_PALETTE = 'cobalt'

function hexToRgbValues(hex) {
  if (!hex || typeof hex !== 'string') return '37, 99, 235';
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16) || 0;
  const g = parseInt(clean.substring(2, 4), 16) || 0;
  const b = parseInt(clean.substring(4, 6), 16) || 0;
  return `${r}, ${g}, ${b}`;
}

export function applyPalette(paletteName, isDark = false) {
  const palette = PALETTES[paletteName] || PALETTES[DEFAULT_PALETTE]
  const colors = isDark ? palette.dark : palette
  const root = document.documentElement

  root.style.setProperty('--primary-blue', colors.primary)
  root.style.setProperty('--primary-blue-dark', colors.primaryDark)
  root.style.setProperty('--primary-blue-light', colors.primaryLight)
  root.style.setProperty('--primary-blue-subtle', colors.primarySubtle)
  root.style.setProperty('--primary-blue-rgb', hexToRgbValues(colors.primary))

  // Backward-compat aliases
  root.style.setProperty('--primary-teal', colors.primary)
  root.style.setProperty('--primary-teal-dark', colors.primaryDark)
  root.style.setProperty('--primary-teal-light', colors.primaryLight)
  root.style.setProperty('--primary-teal-lighter', colors.primaryLighter)

  // Theme tokens
  root.style.setProperty('--theme-primary', colors.primary)
  root.style.setProperty('--theme-primary-dark', colors.primaryDark)
  root.style.setProperty('--theme-primary-light', colors.primaryLight)
  root.style.setProperty('--theme-primary-lighter', colors.primaryLighter)
  root.style.setProperty('--theme-primary-subtle', colors.primarySubtle)
  root.style.setProperty('--theme-primary-rgb', hexToRgbValues(colors.primary))

  // Accent
  root.style.setProperty('--accent-blue', colors.primary)

  // Info color follows primary
  root.style.setProperty('--info', colors.primary)
  root.style.setProperty('--info-border', colors.primaryLighter)
  root.style.setProperty('--info-bg', colors.primarySubtle)
}

export function getPaletteList() {
  return Object.entries(PALETTES).map(([key, p]) => ({
    key,
    name: p.name,
    nameAr: p.nameAr,
    primary: p.primary,
    accent: p.accent,
  }))
}
